/** @format */
import R04db02 from '~/packages/reader/src/.routes/index.jsx';
import R01841d from '~/packages/web/src/components/Pages/.routes/index.jsx';
import R99d472 from '~/packages/workspace/src/.routes/index.jsx';
import R2f18dc from '~/packages/testboard/src/.routes/index.jsx';

export default [...R04db02, ...R01841d, ...R99d472, ...R2f18dc];
